import { Transition } from "@headlessui/react";
import React from "react";
import { useParams } from "react-router-dom";
import Error from "../../common/components/error";
import Loading from "../../common/components/loading";
import { useClientInvitationQuery } from "../../graphql/generated";
import ClientInvitationSummary from "../components/summary";
import ClientInvitationTitle from "../components/title";
import { useTitle } from "../../common/utils/title";

const ClientInvitationShow: React.FC = () => {
  const params = useParams();
  const [{ data, error }] = useClientInvitationQuery({
    variables: { id: params.clientInvitationId ?? "" },
    pause: !params.clientInvitationId,
  });
  useTitle(
    data?.clientInvitation.name ?? params.clientInvitationId,
    "Client Invitations"
  );

  return (
    <>
      <Loading show={!data && !error} />
      <Error error={error} />
      <Transition
        show={!!data}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
      >
        <div className="max-w-7xl mx-auto py-4">
          <ClientInvitationTitle invitation={data?.clientInvitation} />
          <ClientInvitationSummary invitation={data?.clientInvitation} />
        </div>
      </Transition>
    </>
  );
};

export default ClientInvitationShow;
